import BillingError from './BillingError';
import { BillingProvider } from './constants';
import { errors } from '@chaser/codes';

const SUPPORTED_CURRENCIES = ['AUD', 'EUR', 'GBP', 'NZD', 'USD'];
const APP_STORE_SUPPORTED_CURRENCIES = ['GBP', 'AUD', 'NZD'];

const isValidCurrency = (currency, billingService = BillingProvider.CHARGEBEE) => {
  if (currency && billingService === BillingProvider.CHARGEBEE) {
    return SUPPORTED_CURRENCIES.includes(currency);
  }

  if (currency && billingService === BillingProvider.XERO) {
    if (APP_STORE_SUPPORTED_CURRENCIES.includes(currency)) return true;

    throw new BillingError(`${currency} not supported`, {
      provider: BillingProvider.XERO,
      code: errors.CURRENCY_NOT_SUPPORTED,
    });
  }

  return false;
};

const DEFAULT_CURRENCY_FOR_UNSUPPORTED_CURRENCIES = 'USD';

export { isValidCurrency, DEFAULT_CURRENCY_FOR_UNSUPPORTED_CURRENCIES };
